import * as React from 'react';
import { ReactNode } from 'react';
import { cn, useModal } from '@restworld/utils-common';

import { BaseModal } from '@restworld/ui-components';
import { Button } from '@restworld/ui-ds-base';
import { PlusSmallIcon } from '@heroicons/react/24/outline';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IListModalProps {
  children: ReactNode;
  isShowMoreButtonVisible?: boolean;
  modalEl: ReactNode;
}
export const ListModal: React.FunctionComponent<IListModalProps> = ({ children, isShowMoreButtonVisible, modalEl }) => {
  const { show, close, open } = useModal();
  return modalEl ? (
    <>
      {children}
      {isShowMoreButtonVisible && (
        <BaseModal open={show} onClose={close} showMobileGestures={true}>
          <Wrapper>{modalEl}</Wrapper>
        </BaseModal>
      )}
      {isShowMoreButtonVisible && (
        <Button
          onClick={open}
          variant="tertiary"
          className="!shadow-none underline underline-offset-4"
          StartIcon={PlusSmallIcon}
        >
          Mostra di più
        </Button>
      )}
    </>
  ) : null;
};

export default ListModal;
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('pb-3', className)} {...props} />
);
